import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, Button, Select, Radio, DatePicker, InputNumber } from 'antd';
import ButtonStyle from './ButtonStyle';
import Draggable from 'react-draggable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SelectCenter from "./SelectCenter";
import SearchClientPopup from "./SearchClientPopup";
import { confirmAlert } from 'react-confirm-alert';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import ko from 'date-fns/locale/ko';
import { useSelector } from 'react-redux';
import moment from 'moment';
import GetApiHost from './GetApiHost';

registerLocale('ko', ko)

const { Option } = Select;
const { RangePicker } = DatePicker;

const layout = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 9,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
};

const enrollConfig = {
    rules: [
      {
        type: 'array',
        required: true,
        message: '유효기간을 입력해 주세요!',
      },
    ],
};

function CouponPopup(props) {
    const [cid, setCid] = useState('');
    const [showSearch, setShowSearch] = useState(false);
    const [name, setName] = useState('');
    const [selectedCenter, setSelectedCenter] = useState('');
    const [title, setTitle] = useState('');
    const [sdate, setSdate] = useState(null);
    const data = useSelector(state => state.data);
    const [form] = Form.useForm();

    function toggleSearch() {
        setShowSearch(!showSearch)
    }

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
        form.setFieldsValue({
            cid: cid
        });
    }

    function onChange(value){
        let format_sdate = ''
        let format_edate = ''
        if(value){
            if(value[0]){
                format_sdate = moment(value[0]).format();
            }
            if(value[1]){
                format_edate = moment(value[1]).format();
            }
            setSdate(format_sdate)
        }
        
    }

    function onInfoSubmit(name, cd) {
        setName(name);
        form.setFieldsValue({
            name: name,
            cd : cd
        });
    }

    const onFinish = (values) => {
        const { cid, cd, coupon_name, discount_rate, min_price, max_price, val_date, is_use, state } = values;
        let val_sdate = moment(val_date[0]).format('YYYY-MM-DD');
        let val_edate = moment(val_date[1]).format('YYYY-MM-DD');
        if(props.mode === "add") {
            (async function () {
                const api_host = GetApiHost();
                const result = await axios.post(api_host + '/discount_coupon/add_discount_coupon', {
                    mcd : cd,
                    cid: cid,
                    coupon_name : coupon_name,
                    discount_rate : discount_rate,
                    min_price : min_price,
                    max_price : max_price,
                    sdate : val_sdate,
                    edate : val_edate,
                    is_use : is_use,
                    state : state
                })
                if(result.data.ret == 'Y'){
                    alert('등록되었습니다');
                    props.closePopup("updated");
                }else{
                    alert(result.data.msg)
                }
            })();
        }else{
            (async function () {
                const api_host = GetApiHost();
                const result = await axios.post(api_host + '/discount_coupon/edit_discount_coupon', {
                    seq : props.data.seq,
                    cid : cid,
                    coupon_name : coupon_name,
                    discount_rate : discount_rate,
                    min_price : min_price,
                    max_price : max_price,
                    sdate : val_sdate,
                    edate : val_edate,
                    is_use : is_use,
                    state : state
                })
                if(result.data.ret == 'Y'){
                    alert('수정되었습니다');
                    props.closePopup("updated");
                }else{
                    alert(result.data.msg)
                }
            })();
        }
    };

    async function deleteCoupon(seq) {
        const api_host = GetApiHost();
        const result = await axios.post(api_host + '/discount_coupon/delete_discount_coupon', {
            seq : seq
        })
        if(result.data.ret == 'Y'){
            alert('삭제되었습니다');
            props.closePopup("updated");
        }else{
            alert(result.data.msg)
        }
    }

    function handleDelete() {
        confirmAlert({
            title: '삭제 확인',
            message: props.data.name + "님의 쿠폰를 삭제하시겠습니까?",
            buttons: [
              {
                label: 'Yes',
                onClick: () => deleteCoupon(props.data.seq)
              },
              {
                label: 'No'
              }
            ]
          });
    }

    useEffect(()=>{
        if(sdate){
            form.setFieldsValue({
                val_date : [
                    moment(sdate),
                    moment(sdate).add(1, 'y').subtract(1, 'd')
                ]
            });
        }
    },[sdate]);

    useEffect(()=>{
        if(props.mode === "add"){
            setTitle("쿠폰 추가");
            form.setFieldsValue({
                min_price : 60000,
                max_price : 600000,
                is_use : 'N',
                state : 'Y'
            });
        }else if(props.mode === "edit"){
            setTitle("쿠폰 수정");
            setName(props.data.name);
            setCid(props.data.cid);
            let temp_val_sdate = props.data.val_date.substring(0,10);
            let temp_val_edate = props.data.val_date.substring(13,23);
            let temp_val_date = [
                moment(temp_val_sdate),
                moment(temp_val_edate)
            ];
            form.setFieldsValue({
                name : props.data.name,
                cid : props.data.cid,
                coupon_name : props.data.coupon_name,
                discount_rate : props.data.discount_rate,
                min_price : props.data.min_price,
                max_price : props.data.max_price,
                val_date : temp_val_date,
                is_use : props.data.is_use,
                state : props.data.state
            });
        }else{
            alert("정상적인 접근이 아닙니다.")
        }
    },[]);

    return(
        <div className="popup discount">
            <Draggable handle=".handle">
            <div className="popupInner">
            <div className="handle">
            <h3>{title}</h3>
            <FontAwesomeIcon icon={faTimes} onClick={() => props.closePopup("")} className="closeIcon" />
            </div>
            <Form {...layout} form={form} onFinish={onFinish}>
            <Form.Item
                name="name"
                label="고객명"
                rules={[{ required: true, message: '고객명을 입력해 주세요.' }]}
            >
                {props.mode === 'add' ?
                <Input.Group>
                <Input.Search type="text" readOnly={true} className="ant-input-readonly" onSearch={toggleSearch} value={name}/>
                </Input.Group>
                :
                name
                }
            </Form.Item>
            <Form.Item
                name="cid"
                label="센터명"
                rules={[{ required: true, message: '센터를 선택해 주세요.' }]}
            >
                <SelectCenter onSelectedCenter={handleSelectedCenter} defaultValue={cid} width="w-100"/>
            </Form.Item>
            <Form.Item
                name="coupon_name"
                label="쿠폰명"
                rules={[{ required: true, message: '쿠폰명을 입력해 주세요.' }]}
            >
                <Input type="text"/>
            </Form.Item>
            <Form.Item
                name="discount_rate"
                label="할인율"
                rules={[{ required: true, message: '할인율을 입력해 주세요.' }]}
            >
                <Input suffix="%" />
            </Form.Item>
            <Form.Item
                name="min_price"
                label="적용 최소금액"
                rules={[{ required: true, message: '적용 최소금액을 입력해 주세요.' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name="max_price"
                label="적용 최대금액"
                rules={[{ required: true, message: '적용 최대금액을 입력해 주세요.' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item name="val_date" label="유효기간" {...enrollConfig}>
                <RangePicker format="YYYY-MM-DD" onCalendarChange={onChange}/>
            </Form.Item>
            {
                props.mode === 'add' ?
                <></>
                : 
                <>
                <Form.Item name="use_date" label="사용일">
                    {props.data.use_date}
                </Form.Item>
                {/* <Form.Item name="regdate" label="등록일">
                    {props.data.regdate}
                </Form.Item> */}
                </>
            }
            <Form.Item name="is_use" label="사용" rules={[{ required: true, message: '사용여부를 선택해 주세요.' }]}>
                <Select>
                    <Option value="N">미사용</Option>
                    <Option value="Y">사용완료</Option>
                </Select>
            </Form.Item>
            <Form.Item name="state" label="상태" rules={[{ required: true, message: '상태를 선택해 주세요.' }]}>
                <Select>
                    <Option value="Y">Y</Option>
                    <Option value="N">N</Option>
                </Select>
            </Form.Item>
            <Form.Item name="cd" noStyle>
                <Input type="hidden" />
            </Form.Item>
            <Form.Item {...tailLayout}>
                {props.mode === "add" ? 
                    <Button type="primary" htmlType="submit">추가</Button>
                    :
                    <>
                    <Button type="primary" htmlType="submit">수정</Button>
                    &nbsp;
                    <Button type="danger" onClick={handleDelete}>삭제</Button>
                    </>
                }
            </Form.Item>
            </Form>
            
            {showSearch ? 
            <SearchClientPopup
                closePopup={toggleSearch}
                onSubmit = {onInfoSubmit}
                onlyClient
            />
            : null
            }
            </div>
            </Draggable>
        </div>
    )
}

export default CouponPopup;
